// Pfeiltasten-Tree-Navigation fuer Mindmap-Nodes. Pure-Funktionen, kein State.
// `findChild`: erstes Kind nach `y` aufsteigend (oberster Slot).
// `findSiblingNext/Prev`: Geschwister mit gleicher parentNodeId, sortiert nach y dann x.

import type { MindmapNodeObj } from "@ms-whiteboard/shared";

function siblingsOf(
  node: MindmapNodeObj,
  byId: ReadonlyMap<string, MindmapNodeObj>,
): MindmapNodeObj[] {
  const out: MindmapNodeObj[] = [];
  for (const n of byId.values()) {
    if (n.parentNodeId === node.parentNodeId) out.push(n);
  }
  out.sort((a, b) => a.y - b.y || a.x - b.x);
  return out;
}

export function findChild(
  nodeId: string,
  byId: ReadonlyMap<string, MindmapNodeObj>,
): string | null {
  let first: MindmapNodeObj | null = null;
  for (const n of byId.values()) {
    if (n.parentNodeId !== nodeId) continue;
    if (!first || n.y < first.y || (n.y === first.y && n.x < first.x)) first = n;
  }
  return first?.id ?? null;
}

export function findParent(
  nodeId: string,
  byId: ReadonlyMap<string, MindmapNodeObj>,
): string | null {
  return byId.get(nodeId)?.parentNodeId ?? null;
}

export function findSiblingNext(
  nodeId: string,
  byId: ReadonlyMap<string, MindmapNodeObj>,
): string | null {
  const cur = byId.get(nodeId);
  if (!cur) return null;
  const siblings = siblingsOf(cur, byId);
  const idx = siblings.findIndex((s) => s.id === nodeId);
  if (idx === -1 || idx >= siblings.length - 1) return null;
  return siblings[idx + 1]?.id ?? null;
}

export function findSiblingPrev(
  nodeId: string,
  byId: ReadonlyMap<string, MindmapNodeObj>,
): string | null {
  const cur = byId.get(nodeId);
  if (!cur) return null;
  const siblings = siblingsOf(cur, byId);
  const idx = siblings.findIndex((s) => s.id === nodeId);
  if (idx <= 0) return null;
  return siblings[idx - 1]?.id ?? null;
}
